<template>
  <fade-transition>
    <div :class="b()" v-if="isLoading">
      <half-circle-spinner
        :class="b('spinner')"
        :size="spinner.size"
        :color="spinner.color"
        :animation-duration="spinner.animDuration"
      />
    </div>
  </fade-transition>
</template>

<script>
import { mapGetters } from 'vuex';
import { HalfCircleSpinner } from 'epic-spinners';
import FadeTransition from '@/components/transitions/FadeTransition';

export default {
  name: 'Preloader',
  block: 'c-preloader',

  components: {
    HalfCircleSpinner,
    FadeTransition
  },

  data() {
    return {
      spinner: {
        size: 60,
        color: '#ff1d5e',
        animDuration: 1000
      }
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'preloader/isLoading'
    })
  }
};
</script>

<style lang="scss" scoped>
.c-preloader {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999999;
  height: auto;
  width: auto;
  background-color: rgba(0,0,0,.95);

  &__spinner {
    position: absolute !important;
    top: 50%;
    left: 50%;
    margin-top: -30px;
    margin-left: -30px;
  }
}
</style>
